import React from "react";

import IdLogo from '../assets/fulllogo_transparent_nobuffer.png';
import IdBullet from '../assets/bullet.png';

class RhawHeader extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>


                <div style={this.props.style.photo}>
                    <div style={this.props.style.IdBox0}>
                        <div style={this.props.style.IdBoxA}>
                            <div style={this.props.style.IdBoxB}>
                            </div>
                            <div style={this.props.style.IdBoxC}>
                                <div style={this.props.style.IdBoxD}>

                                    <div style={this.props.style.rhawBoxColumns}>
                                        <div style={this.props.style.rhawlogo}><img alt="" src={IdLogo} height="190"/></div>
                                    </div>
                                    <div style={this.props.style.rhawBoxColumns}>
                                        <div style={this.props.style.rhawadjectives}>
                                            <div style={this.props.style.rhawadjective}>
                                                <img alt="" src={IdBullet} width="20" height="20"/>
                                                <div style={this.props.style.rhawadjectiveText}>Professional</div>
                                            </div>
                                            <div style={this.props.style.rhawadjective}>
                                                <img alt="" src={IdBullet} width="20" height="20"/>
                                                <div style={this.props.style.rhawadjectiveText}>Experienced</div>
                                            </div>
                                            <div style={this.props.style.rhawadjective}>
                                                <img alt="" src={IdBullet} width="20" height="20"/>
                                                <div style={this.props.style.rhawadjectiveText}>Dependable</div>
                                            </div>
                                            <div style={this.props.style.rhawadjective}>
                                                <img alt="" src={IdBullet} width="20" height="20"/>
                                                <div style={this.props.style.rhawadjectiveText}>Innovative</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>


            </div>
        )
    }
}

export default RhawHeader


// WEBPACK FOOTER //
// src/static/RhawHeader.js